import React, { useEffect, useRef } from "react";
import { useAtom } from "jotai";
import { languageAtom } from "../atoms/languageAtom";

const BannerText = () => {
  const bannerRef = useRef(null);
  const [language] = useAtom(languageAtom);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        }
      },
      {
        threshold: 0.1, // 10% 이상 보일 때 실행
      }
    );

    observer.observe(bannerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="banner text" ref={bannerRef}>
      <b style={{ display: language === "en" ? "block" : "none" }}>
        Mosu is named after the Korean word for the cosmos flower. 
        <br/>
        This vibrant blossom signals the shift from summer to autumn, <br className="mobile-only" />
        and every year, I look forward to seeing its cheerful colors.
        <br/>
        <br/>
        For me, the cosmos flower symbolizes renewal and growth, <br className="mobile-only" />
        reminding us of the beauty in transitions.<br className="mobile-only" />
        <br/>
        The cooler breezes that follow hot summers<br className="mobile-only" />
        always bring a sense of calm and anticipation for what’s to come.
        <br/>
        <br/>
        Sung Anh
      </b>
      <b
        className="kr"
        style={{ display: language === "kr" ? "block" : "none" }}
      >
        모수(MOSU)는 '코스모스'라는 꽃에서 유래된 이름으로, <br className="mobile-only" />
        이 꽃은 제 마음속에서 특별한 의미를 지닌 존재입니다.<br className="mobile-only" />
        <br />
        무더운 여름이 지나고 불어오는 시원한 바람, <br className="mobile-only" />
        그리고 어린 시절의 즐거운 웃음소리를 떠올리게 합니다.<br className="mobile-only" />
        <br />
        <br />
        "모수를 찾아주시는 모든 분들과 함께 <br className="mobile-only" />
        그러한 따뜻한 기억을 만들어가고 싶습니다."
        <br />
        <br />
        안성재
      </b>
    </div>
  );
};

export default BannerText;
